import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import renderHTML from "react-render-html";
import { getMobilebanner } from "../../store/actions/mobilebanners_action";
import Spinner from "../../components/layout/Spinner";
import SingleItem from "../../components/template/SingleItem";
import { Link } from "react-router-dom";
const ViewMobilebanner = ({
  getMobilebanner,
  match,
  mobilebanner: { loading, mobilebanner },
}) => {
  useEffect(() => {
    getMobilebanner(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Mobilebanners"
          mainLinkTitle="Mobilebanners"
          mainLinkUrl="/mobilebanners"
          activeLink="View"
        />
        {!loading ? (
          mobilebanner && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-4">
                  <div className="card">
                    <div className="card-header">
                      <div>
                        <h4 className="card-title">
                          {mobilebanner.name} <span>View</span>
                        </h4>
                        <p className="card-title-desc">
                          <Link
                            to="/mobilebanners"
                            className="btn btn-soft-light"
                          >
                            <i className="fa fa-angle-left"></i> Mobilebanners
                          </Link>
                          <Link
                            to={`/mobilebanners/${mobilebanner.id}/edit`}
                            className="btn btn-soft-light"
                          >
                            <i className="fa fa-edit"></i>
                          </Link>
                        </p>
                      </div>
                    </div>
                    <div className="card-body">
                      <SingleItem title="title" value={mobilebanner.title} />

                      {mobilebanner.featured_image && (
                        <SingleItem title="Featured Image">
                          <img
                            src={`${mobilebanner.featured_image}`}
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "contain",
                            }}
                          />
                        </SingleItem>
                      )}
                      {mobilebanner.gallery && (
                        <SingleItem title="Gallery">
                          {mobilebanner.gallery.map((pic) => {
                            return (
                              <img
                                src={pic}
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  objectFit: "contain",
                                }}
                              />
                            );
                          })}
                        </SingleItem>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="card">
                    <div className="card-header"> Content </div>
                    <div className="card-body">
                      <div className="card-content">
                        {mobilebanner.content &&
                          renderHTML(mobilebanner.content)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ mobilebanner: state.mobilebanner });

const mapDispatchToProps = { getMobilebanner };

export default connect(mapStateToProps, mapDispatchToProps)(ViewMobilebanner);
